import { render, staticRenderFns } from "./SupervisorWorkerTable.vue?vue&type=template&id=081802fe&scoped=true"
import script from "./SupervisorWorkerTable.vue?vue&type=script&lang=js"
export * from "./SupervisorWorkerTable.vue?vue&type=script&lang=js"
import style0 from "./SupervisorWorkerTable.vue?vue&type=style&index=0&id=081802fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081802fe",
  null
  
)

export default component.exports